"use strict";

class Blog {
    constructor(){
        this.blogUrl = _theme.blogUrl || null;
        if(!this.blogUrl) return;
        this.searchBaseURL = '/search?view=blog&type=article';
        this.searchTerm = '';
        this.buildSelecotrs();
        this.initSideBarEvents();
        this.initPaginationEvents();
        delete _theme.blogUrl;
    }

    buildSelecotrs(){
        this.filterItems = document.querySelectorAll('.blog-filter-custom .select-group ul li a');
        this.searchInputs = document.querySelectorAll('.page-blog form[action="/search"] input[name="q"]');
        this.tagFilterToggle = document.querySelector('.page-blog [data-tag-filter-toggle]');
        this.mobTagSelectItems = document.querySelectorAll('.page-blog .blog-tag-filter .blog-tag-filter--list li a');
    }

    initSideBarEvents(){
        this.filterItems.forEach(item => {
            item.addEventListener('click', evt => {
                evt.preventDefault();
                const parent = item.closest('.select-group');
                if(!item.href || !parent) return;
                parent.querySelectorAll('ul li a').forEach(linkElem => {
                    linkElem.classList.remove('active');
                });
                item.classList.add('active');
                this.fetchArticles(item.href, true);
            });
        });

        this.tagFilterToggle && this.tagFilterToggle.addEventListener('click', evt => {
            const parent = this.tagFilterToggle.parentElement;
            const dropdown = parent.querySelector('.blog-tag-filter--list');
            dropdown.classList.toggle('active');
        });

        this.mobTagSelectItems.forEach(item => {
            item.addEventListener('click', evt => {
                evt.preventDefault();
                const text = item.dataset.text;
                if(!item.href || !text) return;
                this.tagFilterToggle.textContent = text;
                item.closest('.blog-tag-filter--list').classList.remove('active');
                this.fetchArticles(item.href, true);
            });
        });

        let typingTimer;
        this.searchInputs.forEach(input => {
            input.addEventListener('input', (evt) => {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(() => {
                    this.searchTerm = input.value.trim();
                    let fetchUrl = `${this.searchBaseURL}&page=1&q=${this.searchTerm}`;
                    if(!this.searchTerm) fetchUrl = this.blogUrl;
                    this.fetchArticles(fetchUrl, false);
                },  500);
            });
        });
        this.searchInputs.forEach(input => {
            input.addEventListener('keydown', () => {
                clearTimeout(typingTimer);
            });
        });
    }

    initPaginationEvents(){
        const paginationLinks = document.querySelectorAll('.page-content .filter-pagination-wrap ul.pagination li a');
        paginationLinks.forEach(link => {
            link.addEventListener('click', evt => {
                evt.preventDefault();
                if(!link.href) return;
                const currentPage = new URLSearchParams(location.search).get('page');
                const _url = new URL(link.href);
                const newPage = _url.searchParams.get('page');
                if(!newPage) return;
                if(currentPage && newPage && newPage === currentPage) return;
                let fetchUrl =  link.href;
                if(this.searchTerm.trim()) fetchUrl = `${this.searchBaseURL}&page=${newPage}&q=${this.searchTerm}`;
                this.fetchArticles(fetchUrl, false);
            })
        });
    }

    fetchArticles(fetchUrl, updateUri){
        if(!fetchUrl) return;
        this.toggleLoader(1);
        fetch(fetchUrl)
        .then(res => res.text())
        .then(res => {
            this.render(res, fetchUrl, updateUri);
        }).catch(err => {
            this.toggleLoader();
            console.log(err.message);
            // window.location.href = fetchUrl;
        });
    }

    render(res, fetchUrl, updateUri){
        if(!res) return;
        const html = new DOMParser().parseFromString(res, 'text/html');
        const articlesSource = html.querySelector('.article-container');
        const articlesDestination = document.querySelector('.page-content .article-container');
        if(articlesDestination) articlesDestination.innerHTML = articlesSource.innerHTML;

        const paginationSource = html.querySelector('.filter-pagination-wrap');
        const paginationDestinaion = document.querySelector('.page-content .filter-pagination-wrap');
        if(paginationDestinaion) paginationDestinaion.innerHTML = paginationSource.innerHTML;

        if(updateUri) window.history.pushState('', '',fetchUrl);
        this.initPaginationEvents();
        window.scrollTo({top: 0,behavior: 'smooth'});
        this.toggleLoader();
    }

    toggleLoader(show){
        const loadingModal = document.querySelector('.loading-modal');
        if(!loadingModal) return;
        if(show) {
            loadingModal.classList.add('show');
            this.searchInputs.forEach(input => {
                input.setAttribute('readonly', true);
            });
        } else {
            loadingModal.classList.remove('show');
            this.searchInputs.forEach(input => {
                input.removeAttribute('readonly');
            });            
        }
    }
}

window.addEventListener("DOMContentLoaded", function(event){
    new Blog();
});